import {
  loadMessages,
  LocalizationProvider as LocalizationProviderBase,
} from '@progress/kendo-react-intl'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useMount } from 'react-use'

import enMessages from './messages/en.json'
import jaMessages from './messages/ja.json'

export type LocalizationProviderProps = React.PropsWithChildren
const languageMap = (language: string) => {
  switch (language.toLowerCase()) {
    case 'en':
    case 'en-us':
      return 'en'
    case 'ja':
    case 'ja-jp':
      return 'ja'
    default:
      return 'ja'
  }
}

export const LocalizationProvider = ({
  children,
}: LocalizationProviderProps) => {
  const { i18n } = useTranslation()
  useMount(() => {
    loadMessages(jaMessages, 'ja')
    loadMessages(enMessages, 'en')
  })

  const language = useMemo(() => languageMap(i18n.language), [i18n.language])

  return (
    <LocalizationProviderBase language={language}>
      {children}
    </LocalizationProviderBase>
  )
}
